var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 0.999969H2.75C2.19772 0.999969 1.75 1.44768 1.75 1.99997V3.99997C1.75 4.55225 2.19772 4.99997 2.75 4.99997H4.75C5.30228 4.99997 5.75 4.55225 5.75 3.99997V1.99997C5.75 1.44768 5.30228 0.999969 4.75 0.999969Z",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 6.99997H2.75C2.19772 6.99997 1.75 7.44768 1.75 7.99997V9.99997C1.75 10.5523 2.19772 11 2.75 11H4.75C5.30228 11 5.75 10.5523 5.75 9.99997V7.99997C5.75 7.44768 5.30228 6.99997 4.75 6.99997Z",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 7.99994H7.25",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 9.99997H7.25",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.99997H7.25",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 1.99994H7.25",
    stroke: "#E6704B",
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), "\n=======\n", /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16211 1.83331H4.49544C3.75906 1.83331 3.16211 2.43027 3.16211 3.16665V5.83331C3.16211 6.56969 3.75906 7.16665 4.49544 7.16665H7.16211C7.89849 7.16665 8.49544 6.56969 8.49544 5.83331V3.16665C8.49544 2.43027 7.89849 1.83331 7.16211 1.83331Z",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16211 9.83331H4.49544C3.75906 9.83331 3.16211 10.4303 3.16211 11.1666V13.8333C3.16211 14.5697 3.75906 15.1666 4.49544 15.1666H7.16211C7.89849 15.1666 8.49544 14.5697 8.49544 13.8333V11.1666C8.49544 10.4303 7.89849 9.83331 7.16211 9.83331Z",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 11.1665H10.4961",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1628 13.8333H10.4961",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1628 5.83331H10.4961",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 3.16647H10.4961",
    stroke: "#E6704B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.828125 0.5)"
  })))), "\n>>>>>>> e6b7ba3dfde7191692e426c2a9a07860a34d40b7\n"));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.39027abe.svg";
export { ForwardRef as ReactComponent };